<template>
  <div class="c-modal c-modal--contact" :class="{ 'is-active': isActive }">
    <div class="c-modal__bg"></div>
    <div class="c-modal__content">
      <div class="c-modal__close" @click="close">
        <div class="c-icon c-icon--white u-wh14">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <use xlink:href="/assets/img/sprite.svg#close" />
          </svg>
        </div>
      </div>
      <div class="c-modal__inner">
        <div>
          <div class="c-modal__title">
            &lt;head&gt;タグへ下記の記述を追加してください
          </div>
          <div v-if="systemAdminFlg">
            <div  class="c-modal__data">
              <ul class="c-tab-list tag-type">
                <li
                  class="c-tab-list__item"
                  :class="{ 'is-active': selectedTab == 'cdn' }"
                  @click="selectedTab = 'cdn'"
                >
                  CDN経由で設定
                </li>
                <li
                  class="c-tab-list__item"
                  :class="{'is-active': selectedTab == 'download',}"
                  @click="selectedTab = 'download'"
                >
                  サイトにアップロードして設定
                </li>
              </ul>
              <div class="c-textarea">
                <textarea
                  v-model="tagText"
                  style="min-height: 100px"
                  class="c-textarea__item"
                  name="content"
                  placeholder=""
                  readonly="readonly"
                >
                </textarea>
              </div>
            </div>
            <div class="c-modal__btns" @click="download">
              <a class="c-btn c-btn--modal c-btn--gray u-w240 u-h34 u-fs14">
                <p class="c-btn__text">ダウンロード</p>
              </a>
            </div>
          </div>
          <div v-else>
            <div class="c-modal__data">
              <div class="c-textarea">
                <textarea
                  v-model="tagText"
                  style="min-height: 100px"
                  class="c-textarea__item"
                  name="content"
                  placeholder=""
                  readonly="readonly"
                >
                </textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {},
  data() {
    return {
      isActive: false,
      value: "",
      selectedTab: "cdn",
      systemAdminFlg: null,
    };
  },
  computed: {
    tagText: function () {
      if (this.selectedTab == "cdn") {
        const tag = `
<link rel="manifest" href="${this.value}">
        `.trim();
        return tag;
      } else {
        const tag = `
<!-- manifest.jsonはアップロードしたパスを指定してください -->
<link rel="manifest" href="/manifest.json">
        `.trim();
        return tag;
      }
    },
  },
  mounted: function(){
    this.isSystemAdmin();
  },
  methods: {
    download: function () {
      axios
        .get(this.value)
        .then((res) => {
          const blob = new Blob([JSON.stringify(res.data, null, 4)]);
          const link = document.createElement("a");
          link.download = "manifest.json";
          link.href = window.URL.createObjectURL(blob)
          link.click();
        })
        .catch((_error) => {
        });
    },
    open: function () {
      this.isActive = true;
    },
    close: function () {
      this.isActive = false;
    },
    copyAndClose: function () {
      this.$copyText(this.value).then(
        function (_e) { },
        function (_e) { }
      );
      this.isActive = false;
    },
    setValue: function (value) {
      this.value = value;
    },
    isSystemAdmin: function() {
      axios
        .get(`/api/projects/pwa/modal/is-sysmtem-admin`)
        .then((res) => {
          this.systemAdminFlg = res.data;
        })
        .catch((e) => {
          console.log(e);
        });
    }
  },
};
</script>

<style>
.tag-type>li {
  background: white;
  width: 50%;
}

.tag-type li.is-active {
  border-bottom: medium solid #3cb6d2;
}
</style>
